import SaralLogo from '../../../assets/images/powered-by-saral-logo.svg';
import styles from './PoweredBySaral.module.css';

type PoweredBySaralProps = {
  className?: string;
};

export default function PoweredBySaral({ className = '' }: PoweredBySaralProps) {
  return (
    <div className={`${styles.poweredBy} ${className}`}>
      <p className={styles.poweredByText}>Powered by</p>
      <img src={SaralLogo} alt="Saral" width={64} height={16} />
    </div>
  );
}
